export default __webpack_public_path__ + "static/media/cabinet1-before-1440w.d2f570ac.avif";